__turbopack_context__.v({
  "database": "CustomDataTable-module-scss-module__Zbej_G__database",
});
